import { DateTime } from 'luxon'
import StringUtils from '../modules/StringUtils'

const Classification = {
	CHEMICAL: 'CAT_CHEMICAL',
	LABWARE: 'CAT_LABWARE',
	PROTECTION: 'CAT_PROTECTION',
	ETC: 'CAT_ETC',
	CHROMATOGRAPHY: 'CAT_CHROMATOGRAPHY',
	LABETC: 'CAT_LABETC', //실험용품
	OFFICE: 'CAT_OFFICE', //사무용품
	typeToString: type => {
		switch (type) {
			case Classification.CHEMICAL:
				return '화학물질'
			case Classification.CHROMATOGRAPHY:
				return '분석용 칼럼'
			case Classification.LABWARE:
				return '연구장비'
			case Classification.PROTECTION:
				return '보호구'
			case Classification.ETC:
				return '소모품'
			case Classification.LABETC:
				return '실험용품'
			case Classification.OFFICE:
				return '사무용품'
		}
	},
	typeToColor: type => {
		switch (type) {
			case Classification.CHEMICAL:
				return '#FEC741'
			case Classification.CHROMATOGRAPHY:
				return '#DD6FB2'
			case Classification.LABWARE:
				return '#0dc577'
			case Classification.PROTECTION:
				return '#8968f7'
			case Classification.ETC:
				return '#85B5FF'
			case Classification.LABETC:
				return '#85B5FF'
			case Classification.OFFICE:
				return '#85B5FF'
		}
	},
	typeToClass: type => {
		switch (type) {
			case Classification.CHEMICAL:
				return 'yellow'
			case Classification.CHROMATOGRAPHY:
				return 'purple'
			case Classification.LABWARE:
				return 'green'
			case Classification.PROTECTION:
				return 'violet'
			case Classification.ETC:
				return 'skyblue'
			case Classification.LABETC:
				return 'skyblue'
			case Classification.OFFICE:
				return 'skyblue'
		}
	},
	typeToImage: type => {
		switch (type) {
			case Category.REAGENT:
				return 'category-img-reagent.svg'
			case Category.MADE_REAGENT:
				return 'category-img-made-reagent.svg'
			case Category.RAW_MATERIAL:
				return 'category-img-raw-material.svg'
			case Category.MADE_RAW_MATERIAL:
				return 'category-img-made-raw-material.svg'
			case Category.STANDARD:
				return 'category-img-standard.svg'
			case Category.GAS:
				return 'category-img-gas.svg'
			case Category.TOOL:
				return 'category-img-experiment.svg'
			case Category.PROTECTION:
				return 'category-img-protection.svg'
			case Category.CHROMATOGRAPHY:
				return 'category-img-chromatography.svg'
			case Category.EQUIPMENT:
				return 'category-img-equipment.svg'
			case Category.ETC:
				return 'category-img-etc.svg'
			case Category.LABETC:
				return 'category-img-etc.svg'
			case Category.OFFICE:
				return 'category-img-etc.svg'
			default:
				return 'type-reagent.svg'
		}
	},
}

const Category = {
	REAGENT: `${Classification.CHEMICAL}_REAGENT`, // 시약
	MADE_REAGENT: `${Classification.CHEMICAL}_MADE_REAGENT`, // 제조 시약
	RAW_MATERIAL: `${Classification.CHEMICAL}_RAWMATERIAL`, // 원료
	MADE_RAW_MATERIAL: `${Classification.CHEMICAL}_MADE_RAWMATERIAL`, // 제조 원료
	STANDARD: `${Classification.CHEMICAL}_STANDARD`, // 표준품
	GAS: `${Classification.CHEMICAL}_GAS`, // 가스
	CHROMATOGRAPHY: `${Classification.CHROMATOGRAPHY}`, // 분석용 칼럼
	EQUIPMENT: `${Classification.LABWARE}_EQUIPMENT`, // 기계
	TOOL: `${Classification.LABWARE}_TOOL`, // 기구
	PROTECTION: `${Classification.PROTECTION}`, // 보호구
	ETC: `${Classification.ETC}`, // 소모품,
	type2Name: type => {
		switch (type) {
			case Category.REAGENT:
				return '시약'
			case Category.MADE_REAGENT:
				return '제조시약'
			case Category.RAW_MATERIAL:
				return '원료'
			case Category.MADE_RAW_MATERIAL:
				return '제조원료'
			case Category.STANDARD:
				return '표준품'
			case Category.GAS:
				return '가스'
			case Category.CHROMATOGRAPHY:
				return '분석용칼럼'
			case Category.EQUIPMENT:
				return '기계'
			case Category.TOOL:
				return '기구'
			case Category.PROTECTION:
				return '보호구'
			case Category.ETC:
				return '소모품'
		}
	},
}
const RegistMethod = {
	AUTO: {
		IMAGE: 'AUTO_IMAGE',
		DOC: 'AUTO_DOC',
		LMS: 'AUTO_LMS',
	},
	MANUAL: {
		FILE: 'MANUAL_FILE',
		CARGO: 'MANUAL_CARGO',
		DIRECT: 'MANUAL_DIRECT',
		SUBDIVIDE: 'MANUAL_SUBDIVIDE',
	},
	DRAFT: {
		LMS: 'DRAFT_LMS',
		EXTERNAL: 'DRAFT_EXTERNAL',
	},
	isTypeAuto: type => {
		return (
			RegistMethod.AUTO.IMAGE === type ||
			RegistMethod.AUTO.DOC === type ||
			RegistMethod.AUTO.LMS === type
		)
	},
	methodToString: type => {
		switch (type) {
			case RegistMethod.AUTO.IMAGE:
				return '자동등록: 사진 분석'
			case RegistMethod.AUTO.DOC:
				return '자동등록: MSDS / COA 분석'
			case RegistMethod.AUTO.LMS:
				return '자동등록: 스토어'
			case RegistMethod.MANUAL.FILE:
				return '수기등록: 엑셀 업로드'
			case RegistMethod.MANUAL.CARGO:
			case RegistMethod.MANUAL.DIRECT:
				return '수기등록: DB검색 / 직접입력'
			case RegistMethod.MANUAL.SUBDIVIDE:
				return '수기등록: 소분'
			case RegistMethod.DRAFT.LMS:
				return '기안을 통한 등록(랩매니저 스토어)'
			case RegistMethod.DRAFT.EXTERNAL:
				return '기안을 통한 등록(외부거래처)'
			default:
				return '-'
		}
	},
}

const ReasonType = {
	ITEM_CONSUME: 'ITEM_CONSUME', // 사용량 입력
	ITEM_RETURN: 'ITEM_RETURN', // 물품 반납
	ITEM_DELETE: 'ITEM_DELETE', // 물품 삭제
	ITEM_SUBDIVIDE: 'ITEM_SUBDIVIDE', // 물품 소분
	ITEM_DISPOSAL: 'ITEM_DISPOSAL', // 물품 폐기
}

const StatusType = {
	AVAILABLE: 'AVAILABLE',
	UNAVAILABLE: 'UNAVAILABLE',
	HOLDING: 'HOLDING',
	HOLDING_OWN: 'HOLDING_OWN',
	DELETE: 'DELETE',
	DISPOSE: 'DISPOSE',
}

const FieldName = {
	Name: 'name',
	Brand: 'brand',
	ProductCode: 'productCode',
	Subname: 'subname',
	CasNo: 'casno',
	MngCode: 'mngcode',
	IncompanyMngcode: 'incompanyMngcode',
	Ingredient: 'ingredient',
	Location: 'location',
	Storage: 'storage',
	Threshold: 'threshold',
	ThresholdUnit: 'thresholdUnit',
	OpenDatetime: 'openDatetime',
	CreateDatetime: 'createDatetime',
	ExpireDatetime: 'expireDatetime',
	BuyDatetime: 'buyDatetime',
	LotNo: 'lotno',
	Assignee: 'assignee',
	Price: 'price',
	PriceUnit: 'priceUnit',
	Memo: 'memo',
	Register: 'register',
	Buyer: 'buyer',
	RegisterMethod: 'registerMethod',
	MultiCreateCount: 'multiCreateCount',
	Tag: 'tag',
	TagsId: 'tagsId',
	Images: 'images',
	Image: 'image',
	CategoryId: 'categoryId',
	CategoryType: 'categoryType',
	CurrentVolume: 'currentVolume',
	Volume: 'volume',
	InnerDiameter: 'innerDiameter',
	ParticleSize: 'particleSize',
	Length: 'length',
	PoreSize: 'poreSize',
	PhRange: 'phRange',
	UseCount: 'useCount',
	USP: 'usp',
	CarbonLoad: 'carbonLoad',
	Endcapped: 'endcapped',
	Kind: 'kind',
	Model: 'model',
	Spec: 'spec',
	QrSticker: 'qrSticker',
}

const ItemCreate = {
	createMode: {
		IMAGE: 'IMAGE',
		SEARCH: 'SEARCH',
		DIRECT: 'DIRECT',
	},
	state: {
		BASIC_INFO: 'BASIC_INFO',
		MANAGEMENT_INFO: 'MANAGEMENT_INFO',
		COMPLETE: 'COMPLETE',
	},
	infoMode: {
		COUNT: 'COUNT',
		DIVIDE_COUNT: 'DIVIDE_COUNT',
		DIVIDE_MANAGEMENT: 'DIVIDE_MANAGEMENT',
	},
}

const AnalyzeType = {
	tab: {
		ANALYSE: 'ANALYSE',
		CANNOT_ANALYSE: 'CANNOT_ANALYSE',
	},
}

const setEmptyNull = data => {
	if (StringUtils.isEmpty(data)) return null
	else return data
}

const ItemAssign = {
	assignItemInfo: (beforeItem, searchItem, categoryInfo) => {
		const newItem = { ...beforeItem }
		newItem.brand = {
			id: searchItem.brand ? searchItem.brand.id : '',
			name: searchItem.brand ? searchItem.brand.name : '',
		}
		newItem.productCode = setEmptyNull(searchItem.productCode)
		newItem.name = setEmptyNull(searchItem.name)
		newItem.subname = setEmptyNull(searchItem.subname)
		newItem.casno = setEmptyNull(searchItem.casno)
		let volumeUnit =
			setEmptyNull(searchItem.volumeUnit) === 'l'
				? 'L'
				: setEmptyNull(searchItem.volumeUnit)
		newItem.volume = {
			value: setEmptyNull(searchItem.volume),
			unit: volumeUnit,
		}

		if (categoryInfo.classification === Classification.ETC) {
			newItem.currentVolume = {
				value: setEmptyNull(searchItem.currentVolume),
				unit: volumeUnit,
			}
		} else {
			newItem.currentVolume = {
				value: setEmptyNull(searchItem.currentVolume),
				unit: volumeUnit,
			}
		}

		// 분석용 칼럼
		if (categoryInfo.type === Category.CHROMATOGRAPHY) {
			newItem.innerDiameter = setEmptyNull(searchItem.innerDiameter)
			newItem.particleSize = setEmptyNull(searchItem.particleSize)
			newItem.length = {
				value: setEmptyNull(searchItem.length),
				unit: setEmptyNull(searchItem.lengthUnit),
			}

			newItem.poreSize = {
				value: setEmptyNull(searchItem.poreSize),
				unit: setEmptyNull(searchItem.poreSizeUnit),
			}
			newItem.phRange = {
				from: setEmptyNull(searchItem.phRange.from),
				to: setEmptyNull(searchItem.phRange.to),
			}
			newItem.carbonLoad = setEmptyNull(searchItem.carbonLoad)
			newItem.endcapped = setEmptyNull(searchItem.endcapped)
		}

		// 기계
		if (categoryInfo.type === Category.EQUIPMENT) {
			newItem.kind = setEmptyNull(searchItem.kind)
			newItem.modelName = setEmptyNull(searchItem.modelName)
		}

		// 기구
		if (categoryInfo.type === Category.TOOL) {
			newItem.kind = setEmptyNull(searchItem.kind)
			newItem.spec = setEmptyNull(searchItem.spec)
		}

		// 보호구
		if (categoryInfo.type === Category.PROTECTION) {
			newItem.kind = setEmptyNull(searchItem.kind)
		}

		return newItem
	},
}

const Validator = {
	isValid: (fieldList, stdFields) => {
		const requireKeys = fieldList
			.filter(item => item.isRequire && !item.readOnly)
			.map(item => item.key)
		let result = true
		for (let idx = 0; idx < requireKeys.length; idx++) {
			const keyName = requireKeys[idx]
			const fieldData = stdFields[keyName]

			if (keyName === 'name') {
				if (fieldData) {
					result = !fieldData.replace(/\s/g, '') ? false : true
				}
			}

			if (StringUtils.isEmpty(fieldData)) {
				result = false
			}

			if (typeof fieldData === 'object') {
				let datakeys = []
				if (fieldData) {
					datakeys = Object.keys(fieldData)
				}
				for (
					let dataIdx = 0, dataLength = datakeys.length;
					dataIdx < dataLength;
					dataIdx++
				) {
					const datakey = datakeys[dataIdx]
					const objectData = fieldData[datakey]
					if (datakey == 'id' && !StringUtils.isEmpty(objectData)) {
						result = true
						break
					}

					// 이미지가 빈 예외의 경우
					if (datakey === 'image' || datakey === 'parentId') continue

					// value 키 값을 갖는 경우 0초과인 경우 검증 완료
					if (datakey === 'value' && Number(objectData) <= 0) {
						result =
							keyName === 'currentVolume' && objectData === '0'
								? true
								: false
					}

					if (StringUtils.isEmpty(objectData)) {
						result = false
					}
				}
			}
		}

		return result
	},
}

var customArrayValue = 0
const formDataMaker = {
	make: (basic, manage, custom, categoryInfo) => {
		let form = new FormData()
		const { inventoryFields, managementFields, customFields } =
			categoryInfo.fields
		const { type } = categoryInfo
		const invenKeys = inventoryFields
			.filter(item => !item.readOnly)
			.map(item => item.key)
		const manageKeys = managementFields
			.filter(item => !item.readOnly)
			.map(item => item.key)
		const customKeys = customFields
			.filter(item => !item.readOnly)
			.map(item => item.key)

		for (let i = 0, length = invenKeys.length; i < length; i++) {
			formDataMaker.appendData(form, basic, invenKeys[i], i, type)
		}
		for (let i = 0, length = manageKeys.length; i < length; i++) {
			formDataMaker.appendData(form, manage, manageKeys[i], i, type)
		}

		customArrayValue = 0
		for (let i = 0, length = customKeys.length; i < length; i++) {
			formDataMaker.appendData(
				form,
				custom,
				customKeys[i],
				customArrayValue,
				type
			)
		}
		return form
	},
	appendData: (form, field, key, keyIndex, type) => {
		const value = field[key]
		if (StringUtils.isEmpty(value, true)) return
		else if (key.indexOf('custom') >= 0) {
			// 커스텀 필드일때
			if (typeof value === 'object') {
				const date = DateTime.fromJSDate(value)
				if (!date.invalid) {
					form.append(`customField[${keyIndex}][key]`, key)
					form.append(`customField[${keyIndex}][value]`, date)
					customArrayValue += 1
					return
				}

				const isEmpty = !(
					StringUtils.isEmpty(value.value, true) ||
					StringUtils.isEmpty(value.unit, true) ||
					StringUtils.isEmpty(value.id, true) ||
					StringUtils.isEmpty(value.name, true)
				)

				if (!isEmpty) {
					const isSelectMember = Object.keys(value).indexOf('id') >= 0
					const isValueUnit = Object.keys(value).indexOf('unit') >= 0

					if (isSelectMember) {
						form.append(`customField[${keyIndex}][key]`, key)
						form.append(`customField[${keyIndex}][value]`, value.id)
						customArrayValue += 1
						return
					}
					if (isValueUnit) {
						form.append(`customField[${keyIndex}][key]`, key)
						form.append(
							`customField[${keyIndex}][value]`,
							value.value
						)
						customArrayValue += 1
						return
					}
				} else {
					return
				}
			} else {
				form.append(`customField[${keyIndex}][key]`, key)
				form.append(`customField[${keyIndex}][value]`, value)
				customArrayValue += 1
			}
			return
		} else if (typeof value === 'object') {
			const date = DateTime.fromJSDate(value)
			if (!date.invalid) {
				form.append(key, date)
				return
			}

			const keyMap = {
				brand: form => {
					if (value) {
						if (value.id) {
							form.append('brandId', value.id)
						} else if (value.name) {
							form.append('brandName', value.name)
						}
					}
				},
				ingredient: form => {
					for (let i = 0, length = value.length; i < length; i++) {
						const ingredient = value[i]
						form.append(`ingredient[${i}][name]`, ingredient.name)
						form.append(`ingredient[${i}][ratio]`, ingredient.ratio)
						if (!StringUtils.isEmpty(ingredient.casno)) {
							form.append(
								`ingredient[${i}][casno]`,
								ingredient.casno
							)
						}
					}
				},
				storage: form => {
					if (!StringUtils.isEmpty(value.id))
						form.append('storageId', value.id)
				},

				phRange: form => {
					if (!StringUtils.isEmpty(value.from))
						form.append('phRangeFrom', value.from)
					if (!StringUtils.isEmpty(value.to))
						form.append('phRangeTo', value.to)
				},
				images: form => {
					for (let i = 0, length = value.length; i < length; i++) {
						form.append('images', value[i])
					}
				},
				buyer: form => {
					if (!StringUtils.isEmpty(value.id))
						form.append('buyerId', value.id)
				},
				assignee: form => {
					if (!StringUtils.isEmpty(value.id))
						form.append('assigneeId', value.id)
				},
			}

			if (Object.keys(keyMap).indexOf(key) >= 0) {
				keyMap[key](form)
				return
			} else if (Object.keys(value).indexOf('unit') >= 0) {
				const isEmpty = !(
					StringUtils.isEmpty(value.value) ||
					StringUtils.isEmpty(value.unit)
				)
				const isCustom = key.indexOf('custom') >= 0
				const isCurrentValue = key.indexOf('currentVolume') >= 0
				if (isEmpty) {
					form.append(key, value.value)
					if (!isCustom) {
						//소모품 일때 예외처리 ㅠㅠ
						if (type === Category.ETC && isCurrentValue) {
							form.append(`volumeUnit`, value.unit)
						} else {
							form.append(`${key}Unit`, value.unit)
						}
					}
				}
				return
			}
		} else {
			if (key.indexOf('Datetime') >= 0) {
				if (value !== 'Invalid DateTime') {
					form.append(key, value)
				}
			} else {
				form.append(key, value)
			}
			return
		}
		return
	},
}

const categoryToImageDeleted = type => {
	switch (type) {
		case Category.REAGENT:
			return 'category-disabled-reagent.svg'
		case Category.MADE_REAGENT:
			return 'category-disabled-made_reagent.svg'
		case Category.RAW_MATERIAL:
			return 'category-disabled-raw_material.svg'
		case Category.MADE_RAW_MATERIAL:
			return 'category-disabled-made_raw_material.svg'
		case Category.STANDARD:
			return 'category-disabled-standard.svg'
		case Category.GAS:
			return 'category-disabled-gas.svg'
		case Category.CHROMATOGRAPHY:
			return 'category-disabled-chromatography.svg'
		case Category.EQUIPMENT:
			return 'category-disabled-equipment.svg'
		case Category.TOOL:
			return 'category-disabled-tool.svg'
		case Category.PROTECTION:
			return 'category-disabled-protection.svg'
		case Category.ETC:
			return 'category-disabled-etc.svg'
	}
}

const imageRoot = '@/assets/svg'
const categoryToImage = type => {
	switch (type) {
		case Category.REAGENT:
			return `category-img-reagent.svg`
		case Category.MADE_REAGENT:
			return `category-img-made-reagent.svg`
		case Category.RAW_MATERIAL:
			return `category-img-raw-material.svg`
		case Category.MADE_RAW_MATERIAL:
			return `category-img-made-raw-material.svg`
		case Category.STANDARD:
			return `category-img-standard.svg`
		case Category.GAS:
			return `category-img-gas.svg`
		case Category.TOOL:
			return `category-img-experiment.svg`
		case Category.PROTECTION:
			return `category-img-protection.svg`
		case Category.CHROMATOGRAPHY:
			return `category-img-chromatography.svg`
		case Category.EQUIPMENT:
			return `category-img-equipment.svg`
		case Category.ETC:
			return `category-img-etc.svg`
		default:
			return `category-img-reagent.svg`
	}
}

const CategoryTypeList = {
	CAT_CHEMICAL: [
		Category.REAGENT,
		Category.MADE_REAGENT,
		Category.RAW_MATERIAL,
		Category.STANDARD,
		Category.GAS,
	],
	CAT_CHROMATOGRAPHY: [Category.CHROMATOGRAPHY],
	CAT_LABWARE: [Category.EQUIPMENT, Category.TOOL],
	CAT_TOOL: [Category.TOOL],
	CAT_PROTECTION: [Category.PROTECTION],
	CAT_ETC: [Category.ETC],
}

const MiddleClassToString = type => {
	switch (type) {
		case Category.REAGENT:
			return '시약'
		case Category.MADE_REAGENT:
			return '제조 시약'
		case Category.RAW_MATERIAL:
			return '원료'
		case Category.STANDARD:
			return '표준품'
		case Category.GAS:
			return '가스'
		case Category.CHROMATOGRAPHY:
			return '분석용칼럼'
		case Category.EQUIPMENT:
			return '기계'
		case Category.TOOL:
			return '기구'
		case Category.PROTECTION:
			return '보호구'
		case Category.ETC:
			return '소모품'
	}
}

const FindClassification = categoryType => {
	let result = null
	Object.keys(CategoryTypeList).forEach(key => {
		if (CategoryTypeList[key].includes(categoryType)) {
			result = key
		}
	})
	return result
}

export {
	Category,
	Classification,
	RegistMethod,
	ReasonType,
	StatusType,
	FieldName,
	ItemCreate,
	ItemAssign,
	Validator,
	formDataMaker,
	AnalyzeType,
	MiddleClassToString,
	categoryToImageDeleted,
	categoryToImage,
	FindClassification,
}
